(function galleryOnPageInit(global) {
  'use strict';

  if (!global.NewHomeSource.GalleryOnPage.Index ||
      !global.NewHomeSource.Lightbox.Index ||
      !global.NewHomeSource.GalleryOnPage.CommunityTracking.Index) {
    return;
  }

  const rootElement = document.querySelector('[data-component="gallery-on-page"]');
  if (!rootElement) {
    return;
  }

  const galleryOnPage = new global.NewHomeSource.GalleryOnPage.Index();
  galleryOnPage
    .setRootElement(rootElement)
    .create();

  const lightbox = new global.NewHomeSource.Lightbox.Index();
  lightbox
    .setTemplate(document.querySelector('[data-component="lightbox-template"]'))
    .bindEvents();

  const communityTracking = new global.NewHomeSource.GalleryOnPage.CommunityTracking.Index();
  communityTracking
    .setRootElement(rootElement)
    .create();
}(window));
